import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useAppDispatch } from '../../../store'
import { logout } from '../../ducks'
import { resetLogin } from '../../ducks/login'

const LogoutPage: React.FC = () => {
  const location = useLocation()
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(logout())
    dispatch(resetLogin())
  })

  return <Navigate to="/account/login" state={{ from: location }} />
}

export default LogoutPage
